export default "__VITE_ASSET__CVP4muM5__"